;(function($, window, document, undefined) {
	var $win = $(window);
	var $doc = $(document);

	$.fn.equalizeHeight = function() {
		var hght = 0;
		var $this = this;

		$this.outerHeight('auto');

		$this.each(function(){
			var itemHght = $(this).outerHeight();

			if (itemHght > hght) {
				hght = itemHght;
			}
		});

		$this.outerHeight(hght);
	}

	function initMultipleMaps() {
		var $map = $('.map');

		$map.each(function(index, element){
			var $this = $(this);

			var mapCenter = $this.data('center');
			var pinIcon = $this.data('pin');

			var styles = [{
				featureType: 'all',
				elementType: 'all',
				stylers: [
					{ saturation: -100 }
				]}
			];

			var mapOptions = {
				zoom: 16,
				center: mapCenter,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				disableDefaultUI: true,
				disableDoubleClickZoom: true,
				mapTypeControl: false,
				zoomControl: false,
				fullScreenControl: false,
				gestureHandling: 'none',
				panControl: false,
				scrollwheel: false,
				zoomControlOptions: {
					style: google.maps.ZoomControlStyle.SMALL
				}
			};

			map = new google.maps.Map(element, mapOptions);

			var marker = new google.maps.Marker({
				position: mapCenter,
				map: map,
				icon: pinIcon
			});

			var mapType = new google.maps.StyledMapType(styles, {
				name: 'Grayscale'
			});

			map.mapTypes.set('tehgrayz', mapType);
			map.setMapTypeId('tehgrayz');

			google.maps.event.addListener(map, 'resize', function() {
				setTimeout(function() {
					map.setCenter(mapCenter);
				}, 10);
			});
		})
	}
	function resize_map_height(){
		//console.log($win.height() , $("footer").height())
		$('.map').css('height', ($win.height() - $("footer").height())+"px")
	}
	

	$doc.ready(function() {
		if($('.map').length){	
			resize_map_height(); 
			$win.resize(function(){
				resize_map_height();
			});	
		}
		/*
			JS Ico
		 */
		$('.js-ico').on('click', function(){
			var target = $(this).closest('.slider').next('section').offset().top

			$('html, body').animate({
				scrollTop : target
			})
		})

		/*
			Button Burger
		 */

		$('.btn-burger').on('click', function(e) {
			e.preventDefault();

			$(this).toggleClass('active')
			$('.header').toggleClass('active')
		})

	});

	$win.on('load', function(){
		/*
			Slider
		 */

		if($('.slider').length) {
			$('.slider .slider__slides').slick({
				arrows: false,
				infinite: true,
				speed: 700,
				autoplay: true,
				autoplaySpeed: 5000
			})
		}

		/*
			Map
		 */
		if ($('.map').length) {
			initMultipleMaps()
		}

		$('.slider .slider__slide').outerHeight($win.outerHeight())
	}).on('load resize', function(){
		if($win.width() > 767) {
			/*
				Equalize section image height
			 */

			$('.cols').each(function(){
				$(this).find('.section__image img').equalizeHeight()
			})
		}
	})

	$('.footer__logo').on("click",function() {
	    $('html, body').animate({ scrollTop: 0 }, 400);
	});
})(jQuery, window, document);
